const profileImage1 = "data:image/png;base64,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";
const profileImage2 = "";

const admin = {
    "isEmailVerified": true,
    "isPhoneVerified": true,
    "isTwoFactorOn": false,
    "isActive": true,
    "username": "Admin Test",
    "email": "admin@test.com",
    "password": "Abcd1234",
    "token": "",
    "roles": ["admin"],
    "__v": 2,
    "guideTakenFor": [],
    "acceptedCookiePolicy": {
        "status": false
    },
    "acceptedPrivacyPolicy": {
        "status": false
    },
    "acceptedTnC": {
        "status": false
    },
    "notifications": {
        "AvailableTimings": [],
        "ClientChat": [],
        "ClientDashboard": [],
        "ClientProfile": [],
        "ProviderChat": [],
        "ProviderPayment": [],
        "ProviderProfile": [],
        "ProviderSession": [],
        "MyClient": [],
        "MyPricing": [],
        "System": []
    }
};

const users = [{
    _id: "client",
    username: "Mr. Sanjay Sharma",
    title: "Mr.",
    firstName: "Sanjay",
    lastName: "Sharma",
    email: "sanjay_sharma@email.com",
    token: "",
    password: "Abcd1234",
    isEmailVerified: true,
    isPhoneVerified: true,
    isTwoFactorOn: true,
    roles: ['client'],
    isActive: true,
    loginCount: 3,
    lastLoginAt: {
        old: "",
        new: ""
    },
    acceptedTnC: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedPrivacyPolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedCookiePolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    guideTakenFor: [],
    notifications: {
        System: [],
        ProviderProfile: [],
        ProviderSession: [],
        ProviderChat: [],
        AvailableTimings: [],
        MyPricing: [],
        MyClient: [],
        ProviderPayment: [],
        ClientProfile: [],
        ClientDashboard: [],
        ClientChat: []
    }
}, {
    _id: "provider",
    username: "Mr. Bharat Prasad",
    title: "Mr.",
    firstName: "Bharat",
    lastName: "Prasad",
    email: "bharat_prasad@email.com",
    token: "",
    password: "Abcd1234",
    isEmailVerified: true,
    isPhoneVerified: true,
    isTwoFactorOn: true,
    roles: ['client'],
    isActive: true,
    loginCount: 5,
    lastLoginAt: {
        old: "",
        new: ""
    },
    acceptedTnC: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedPrivacyPolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedCookiePolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    guideTakenFor: [],
    notifications: {
        System: [],
        ProviderProfile: [],
        ProviderSession: [],
        ProviderChat: [],
        AvailableTimings: [],
        MyPricing: [],
        MyClient: [],
        ProviderPayment: [],
        ClientProfile: [],
        ClientDashboard: [],
        ClientChat: []
    }
}, {
    _id: "user3",
    username: "Mr. Rajesh Patel",
    title: "Mr.",
    firstName: "Rajesh",
    lastName: "Patel",
    email: "rejesh_patel@email.com",
    token: "",
    password: "Abcd1234",
    isEmailVerified: true,
    isPhoneVerified: true,
    isTwoFactorOn: true,
    roles: ['provider'],
    isActive: true,
    loginCount: 5,
    lastLoginAt: {
        old: "",
        new: ""
    },
    acceptedTnC: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedPrivacyPolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedCookiePolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    guideTakenFor: [],
    notifications: {
        System: [],
        ProviderProfile: [],
        ProviderSession: [],
        ProviderChat: [],
        AvailableTimings: [],
        MyPricing: [],
        MyClient: [],
        ProviderPayment: [],
        ClientProfile: [],
        ClientDashboard: [],
        ClientChat: []
    }
}, {
    _id: "user4",
    username: "Mr. Saurabh Panjabi",
    title: "Mr.",
    firstName: "Saurabh",
    lastName: "Panjabi",
    email: "saurabh_panjabi@email.com",
    token: "",
    password: "Abcd1234",
    isEmailVerified: true,
    isPhoneVerified: true,
    isTwoFactorOn: true,
    roles: ['provider'],
    isActive: true,
    loginCount: 5,
    lastLoginAt: {
        old: "",
        new: ""
    },
    acceptedTnC: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedPrivacyPolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    acceptedCookiePolicy: {
        status: true,
        effectiveFrom: "",
        acceptedOn: ""
    },
    guideTakenFor: [],
    notifications: {
        System: [],
        ProviderProfile: [],
        ProviderSession: [],
        ProviderChat: [],
        AvailableTimings: [],
        MyPricing: [],
        MyClient: [],
        ProviderPayment: [],
        ClientProfile: [],
        ClientDashboard: [],
        ClientChat: []
    }
}]

const clients = [{
    _id: "client1",
    user: "client",
    isActive: true,
    title: "Mr.",
    firstName: "Sanjay",
    lastName: "Sharma",
    email: "sanjay_sharma@email.com",
    birthDate: "20-08-1987",
    gender: "male",
    phone: "919876543210",
    address1: "A-24, RiverView Heights",
    address2: "Adajan",
    pincode: "390009",
    city: "Surat",
    state: "Gujarat",
    country: "India",
    clientForm: "",
    selectedProvider: {
        isTrue: true,
        formFilled: "",
        provider: "provider1"
    },
    clientSubscriptions: "",//{ type: [mongoose.Schema.Types.ObjectId], ref: 'ClientSubscription' },
    twilioId: "",
    profileComplete: true,
    sessionList: [],//{ type: [mongoose.Schema.Types.ObjectId], ref: 'Session' },
    reminders: {
        selectProvider: true,
        freeSession: true
    },
    profileImage: profileImage1
}, {
    _id: "client2",
    user: "provider",
    isActive: true,
    title: "Mr.",
    firstName: "Bharat",
    lastName: "Prasad",
    email: "bharat_prasad@email.com",
    birthDate: "20-08-1987",
    gender: "male",
    phone: "919876543210",
    address1: "128, Rudra Residency",
    address2: "Nizampura",
    pincode: "390012",
    city: "Vadodara",
    state: "Gujarat",
    country: "India",
    clientForm: "",
    selectedProvider: {
        isTrue: true,
        formFilled: "",
        provider: "provider2"
    },
    clientSubscriptions: "",//{ type: [mongoose.Schema.Types.ObjectId], ref: 'ClientSubscription' },
    twilioId: "",
    profileComplete: true,
    sessionList: [],//{ type: [mongoose.Schema.Types.ObjectId], ref: 'Session' },
    reminders: {
        selectProvider: true,
        freeSession: true
    },
    profileImage: profileImage1
}]

const counsellors = [{
    _id: "counsellor1",
    user: "user3",
    isActive: true,
    isApproved: true,
    title: "Mr.",
    firstName: "Rajesh",
    lastName: "Patel",
    email: "rejesh_patel@email.com",
    birthDate: "01-01-1990",
    gender: "male",
    phone: "919876543210",
    address1: "12, Netaji Park",
    address2: "Raj Mahal road",
    pincode: "390001",
    city: "Vadodara",
    state: "Gujarat",
    country: "India",
    providerUniqueId: "rajesh_patel",
    providerIDSelected: true,
    reportCharge: 500,
    modeOfService: {
        call: {
            name: "Call",
            isTrue: true,
            rate: 1000
        },
        chat: {
            name: "Chat",
            isTrue: true,
            rate: 2000
        },
        video: {
            name: "Video",
            isTrue: true,
            rate: 3000
        },
        inPerson: {
            name: "In Person",
            isTrue: true,
            rate: 4000
        }
    },
    languages: ["English", "Hindi", "Gujarati"],
    description: "I am a verified professional counsellor having masters degree. I will help you all sort of situation in best way.",
    specialities: ["Anxiety", "Relationship"],
    degrees: ["Bachelors", "Masters"],
    timeZone: "+05:30",
    availableTimes: [{
        from: "2022-07-27T04:30:00.000Z",
        to: "2022-07-27T08:30:00.000Z"
    }, {
        from: "2022-08-16T09:30:00.000Z",
        to: "2022-08-16T11:30:00.000Z"
    }],
    // change here done
    availableDaysAndBookedTimings: [],
    totalMoneyEarned: 10000,
    pendingPayment: 0,
    clientList: [{
        isReportIncluded: true,
        sessionsDone: 4,
        clientId: "client1"
    }],
    clientSubscriptionPlans: "clientSubscriptionPlan1",
    twilioId: "",
    sessionList: "session1",
    profileComplete: true,
    profileImage: profileImage1,
    socialLinkFacebook: "",
    socialLinkInstagram: "",
    socialLinkTwitter: "",
    socialLinkYoutube: "",
    socialLinkQuora: "",
    socialLinkMedium: "",
    socialLinkLinkedin: "",
    providerSubscriptions: "providerSubscription1",
}, {
    _id: "counsellor2",
    user: "user4",
    isActive: true,
    isApproved: true,
    title: "Mr.",
    firstName: "Saurabh",
    lastName: "Panjabi",
    email: "saurabh_panjabi@email.com",
    birthDate: "12-11-1985",
    gender: "male",
    phone: "919876543210",
    address1: "12, Solitare Villa",
    address2: "Kareli Baug",
    pincode: "390020",
    city: "Vadodara",
    state: "Gujarat",
    country: "India",
    providerUniqueId: "saurabh_panjabi",
    providerIDSelected: true,
    reportCharge: 700,
    modeOfService: {
        call: {
            name: "Call",
            isTrue: true,
            rate: 1200
        },
        chat: {
            name: "Chat",
            isTrue: true,
            rate: 2200
        },
        video: {
            name: "Video",
            isTrue: true,
            rate: 3200
        },
        inPerson: {
            name: "In Person",
            isTrue: true,
            rate: 4200
        }
    },
    languages: ["English", "Hindi", "Punjabi"],
    description: "I am a verified professional counsellor having masters degree. I will help you all sort of situation in best way.",
    specialities: ["Anxiety", "Relationship", "Stress"],
    degrees: ["Bachelors", "Masters"],
    timeZone: "+05:30",
    availableTimes: [{
        from: "2022-07-27T06:30:00.000Z",
        to: "2022-07-27T08:30:00.000Z"
    }, {
        from: "2022-08-16T11:00:00.000Z",
        to: "2022-08-16T12:00:00.000Z"
    }],
    // change here done
    availableDaysAndBookedTimings: [],
    totalMoneyEarned: 15000,
    pendingPayment: 2200,
    clientList: [{
        isReportIncluded: true,
        sessionsDone: 3,
        clientId: "client2"
    }],
    clientSubscriptionPlans: "clientSubscriptionPlan2",
    twilioId: "",
    sessionList: "session2",
    profileComplete: true,
    profileImage: profileImage1,
    socialLinkFacebook: "",
    socialLinkInstagram: "",
    socialLinkTwitter: "",
    socialLinkYoutube: "",
    socialLinkQuora: "",
    socialLinkMedium: "",
    socialLinkLinkedin: "",
    providerSubscriptions: "providerSubscription2",
}];

const sessions = [{
    _id: "session1",
    isReportIncluded: {
        status: false,
        amount: 0
    },
    createdByProvider: {
        status: false,
        isFreeSession: false
    },
    status: false,
    isRescheduled: false,
    isCancelled: false,
    refundProcessed: false,
    client: clients[0],
    provider: counsellors[0],
    time: [{
        from: "2022-08-29T04:30:00.000Z",
        to: "2022-08-29T05:00:00.000Z"
    }],
    date: "2022-08-29T04:30:00.000Z",
    modeOfServiceSelected: "Call",
    paymentId: {
        _id: "635dfd6bb567190047fc08c1",
        payment: {
            razorpay_payment_id: "pay_KZqppdqFedudv7",
            amount: "1000.00"
        }
    },
    createdAt: "2022-08-27T00:28:23.378Z",
    updatedAt: "2022-08-27T00:28:23.378Z"
}, {
    _id: "session2",
    isReportIncluded: {
        status: false,
        amount: 0
    },
    createdByProvider: {
        status: false,
        isFreeSession: false
    },
    status: false,
    isRescheduled: false,
    isCancelled: false,
    refundProcessed: false,
    client: "client1",
    provider: "provider1",
    time: [{
        from: "2022-08-28T03:30:00.000Z",
        to: "2022-08-28T04:00:00.000Z"
    }],
    date: "2022-08-28T03:30:00.000Z",
    modeOfServiceSelected: "Call",
    clientSubscriptionId: "clientSubscription1",
    createdAt: "2022-08-26T00:28:23.378Z",
    updatedAt: "2022-08-26T00:28:23.378Z"
}];

const siteVariable = {
    advanceBookingLimit: 15,
    totalRazorpayCharges: 0,
    GSTPercentage: 0,
    totalGSTCollected: 0,
    totalPaidToProviders: 0,
    totalPendingPayments: 0,
    netIncome: 0,
    totalRazorpayChargesCollected: 0,
    timeSlotSize: 30,
    minimumAgeForClient: 18,
    minimumReportCharge: 100,
    minimumServiceCharges: {
        call: 100,
        chat: 100,
        video: 100,
        inPerson: 100,
    },
    paymentCycle: {
        period: 14,
        currentPeriodFrom: "",
        currentPeriodTo: "",
        expectedPaymentDate: "",
        nextPeriod: 14
    },
    clientSubscriptionPlanRange: {
        from: 499,
        to: 9999,
        interval: 100
    },
    providerSubscriptionPlanRange: {
        from: 499,
        to: 9999,
        interval: 100
    },
    providerLanguages: ["English", "Hindi", "Gujarati"],
    providerSpecialities: ["Stress", "Anxiety", "Relationship"],
    userTitles: ['Mr.', 'Mrs.', 'Miss.', 'Ms.', 'Sir.', 'Madam.', 'Dr.'],
    listOfTimeZones: {
        type: [{ Object }], default: [{
            "label": "(UTC-12:00) International Date Line West",
            "offset": "-12:00",
            "dst_offset": "−12:00",
            "value": ["Etc/GMT+12"]
        }, {
            "label": "(UTC-11:00) Coordinated Universal Time-11",
            "offset": "-11:00",
            "dst_offset": "−11:00",
            "value": ["Etc/GMT+11"]
        }, {
            "label": "(UTC-10:00) Hawaii",
            "offset": "-10:00",
            "dst_offset": "−10:00",
            "value": ["Pacific/Honolulu", "Pacific/Johnston", "US/Hawaii"]
        }, {
            "label": "(UTC-09:00) Alaska",
            "offset": "-09:00",
            "dst_offset": "−08:00",
            "value": ["America/Anchorage", "US/Alaska"]
        }, {
            "label": "(UTC-08:00) Baja California",
            "offset": "-08:00",
            "dst_offset": "−07:00",
            "value": ["America/Santa_Isabel"]
        }, {
            "label": "(UTC-08:00) Pacific Time (US and Canada)",
            "offset": "-08:00",
            "dst_offset": "−07:00",
            "value": ["America/Los_Angeles", "US/Pacific"]
        }, {
            "label": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
            "offset": "-07:00",
            "dst_offset": "−06:00",
            "value": ["America/Chihuahua"]
        }, {
            "label": "(UTC-07:00) Arizona",
            "offset": "-07:00",
            "dst_offset": "−07:00",
            "value": ["America/Creston", "America/Phoenix", "US/Arizona"]
        }, {
            "label": "(UTC-07:00) Mountain Time (US and Canada)",
            "offset": "-07:00",
            "dst_offset": "−06:00",
            "value": ["America/Denver", "America/Shiprock", "Navajo", "US/Mountain"]
        }, {
            "label": "(UTC-06:00) Central America",
            "offset": "-06:00",
            "dst_offset": "−06:00",
            "value": ["America/Guatemala"]
        }, {
            "label": "(UTC-06:00) Central Time (US and Canada)",
            "offset": "-06:00",
            "dst_offset": "−05:00",
            "value": ["America/Chicago", "US/Central"]
        }, {
            "label": "(UTC-06:00) Saskatchewan",
            "offset": "-06:00",
            "dst_offset": "−06:00",
            "value": ["America/Regina", "Canada/Saskatchewan"]
        }, {
            "label": "(UTC-06:00) Guadalajara, Mexico City, Monterey",
            "offset": "-06:00",
            "dst_offset": "−05:00",
            "value": ["America/Mexico_City", "Mexico/General"]
        }, {
            "label": "(UTC-05:00) Bogota, Lima, Quito",
            "offset": "-05:00",
            "dst_offset": "−05:00",
            "value": ["America/Bogota"]
        }, {
            "label": "(UTC-05:00) Indiana (East)",
            "offset": "-05:00",
            "dst_offset": "−04:00",
            "value": ["America/Fort_Wayne", "America/Indiana/Indianapolis", "America/Indianapolis", "US/East-Indiana"]
        }, {
            "label": "(UTC-05:00) Eastern Time (US and Canada)",
            "offset": "-05:00",
            "dst_offset": "−04:00",
            "value": ["America/New_York", "US/Eastern"]
        }, {
            "label": "(UTC-04:30) Caracas",
            "offset": "-04:30",
            "dst_offset": "−04:00",
            "value": ["America/Caracas"]
        }, {
            "label": "(UTC-04:00) Atlantic Time (Canada)",
            "offset": "-04:00",
            "dst_offset": "−03:00",
            "value": ["America/Halifax", "Canada/Atlantic"]
        }, {
            "label": "(UTC-04:00) Asuncion",
            "offset": "-04:00",
            "dst_offset": "−03:00",
            "value": ["America/Asuncion"]
        }, {
            "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
            "offset": "-04:00",
            "dst_offset": "−04:00",
            "value": ["America/La_Paz"]
        }, {
            "label": "(UTC-04:00) Cuiaba",
            "offset": "-04:00",
            "dst_offset": "−04:00",
            "value": ["America/Cuiaba"]
        }, {
            "label": "(UTC-04:00) Santiago",
            "offset": "-04:00",
            "dst_offset": "−03:00",
            "value": ["America/Santiago", "Chile/Continental"]
        }, {
            "label": "(UTC-03:30) Newfoundland",
            "offset": "-03:30",
            "dst_offset": "−02:30",
            "value": ["America/St_Johns", "Canada/Newfoundland"]
        }, {
            "label": "(UTC-03:00) Brasilia",
            "offset": "-03:00",
            "dst_offset": "−03:00",
            "value": ["America/Sao_Paulo", "Brazil/East"]
        }, {
            "label": "(UTC-03:00) Greenland",
            "offset": "-03:00",
            "dst_offset": "−02:00",
            "value": ["America/Godthab"]
        }, {
            "label": "(UTC-03:00) Cayenne, Fortaleza",
            "offset": "-03:00",
            "dst_offset": "−03:00",
            "value": ["America/Cayenne"]
        }, {
            "label": "(UTC-03:00) Buenos Aires",
            "offset": "-03:00",
            "dst_offset": "−03:00",
            "value": ["America/Argentina/Buenos_Aires", "America/Buenos_Aires"]
        }, {
            "label": "(UTC-03:00) Montevideo",
            "offset": "-03:00",
            "dst_offset": "−03:00",
            "value": ["America/Montevideo"]
        }, {
            "label": "(UTC-02:00) Coordinated Universal Time-2",
            "offset": "-02:00",
            "dst_offset": "−02:00",
            "value": ["Etc/GMT+2"]
        }, {
            "label": "(UTC-01:00) Cape Verde",
            "offset": "-01:00",
            "dst_offset": "−01:00",
            "value": ["Atlantic/Cape_Verde"]
        }, {
            "label": "(UTC-01:00) Azores",
            "offset": "-01:00",
            "dst_offset": "+00:00",
            "value": ["Atlantic/Azores"]
        }, {
            "label": "(UTC+00:00) Casablanca",
            "offset": "+00:00",
            "dst_offset": "+00:00",
            "value": ["Africa/Casablanca"]
        }, {
            "label": "(UTC+00:00) Monrovia, Reykjavik",
            "offset": "+00:00",
            "dst_offset": "+00:00",
            "value": ["Atlantic/Reykjavik", "Iceland"]
        }, {
            "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
            "offset": "+00:00",
            "dst_offset": "+01:00",
            "value": ["Europe/Belfast", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Jersey", "Europe/London", "GB", "GB-Eire"]
        }, {
            "label": "(UTC+00:00) Coordinated Universal Time",
            "offset": "+00:00",
            "dst_offset": "+00:00",
            "value": ["Etc/GMT", "Etc/GMT+0", "Etc/GMT-0", "Etc/GMT0", "Etc/Greenwich", "GMT", "GMT+0", "GMT-0", "GMT0", "Greenwich"]
        }, {
            "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            "offset": "+01:00",
            "dst_offset": "+02:00",
            "value": ["Europe/Berlin"]
        }, {
            "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
            "offset": "+01:00",
            "dst_offset": "+02:00",
            "value": ["Europe/Paris"]
        }, {
            "label": "(UTC+01:00) West Central Africa",
            "offset": "+01:00",
            "dst_offset": "+01:00",
            "value": ["Africa/Bangui", "Africa/Brazzaville", "Africa/Douala", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Luanda", "Africa/Malabo", "Africa/Niamey", "Africa/Porto-Novo"]
        }, {
            "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            "offset": "+01:00",
            "dst_offset": "+02:00",
            "value": ["Europe/Budapest"]
        }, {
            "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            "offset": "+01:00",
            "dst_offset": "+02:00",
            "value": ["Europe/Warsaw", "Poland"]
        }, {
            "label": "(UTC+01:00) Windhoek",
            "offset": "+01:00",
            "dst_offset": "+02:00",
            "value": ["Africa/Windhoek"]
        }, {
            "label": "(UTC+02:00) Athens, Bucharest, Istanbul",
            "offset": "+02:00",
            "dst_offset": "+03:00",
            "value": ["Asia/Istanbul", "Europe/Istanbul", "Turkey"]
        }, {
            "label": "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
            "offset": "+02:00",
            "dst_offset": "+03:00",
            "value": ["Europe/Kiev"]
        }, {
            "label": "(UTC+02:00) Cairo",
            "offset": "+02:00",
            "dst_offset": "+02:00",
            "value": ["Africa/Cairo", "Egypt"]
        }, {
            "label": "(UTC+02:00) Damascus",
            "offset": "+02:00",
            "dst_offset": "+03:00",
            "value": ["Asia/Damascus"]
        }, {
            "label": "(UTC+02:00) Amman",
            "offset": "+02:00",
            "dst_offset": "+03:00",
            "value": ["Asia/Amman"]
        }, {
            "label": "(UTC+02:00) Harare, Pretoria",
            "offset": "+02:00",
            "dst_offset": "+02:00",
            "value": ["Africa/Johannesburg", "Africa/Maseru", "Africa/Mbabane"]
        }, {
            "label": "(UTC+02:00) Jerusalem",
            "offset": "+02:00",
            "dst_offset": "+03:00",
            "value": ["Asia/Jerusalem", "Asia/Tel_Aviv", "Israel"]
        }, {
            "label": "(UTC+02:00) Beirut",
            "offset": "+02:00",
            "dst_offset": "+03:00",
            "value": ["Asia/Beirut"]
        }, {
            "label": "(UTC+03:00) Baghdad",
            "offset": "+03:00",
            "dst_offset": "+03:00",
            "value": ["Asia/Baghdad"]
        }, {
            "label": "(UTC+03:00) Minsk",
            "offset": "+03:00",
            "dst_offset": "+03:00",
            "value": ["Europe/Minsk"]
        }, {
            "label": "(UTC+03:00) Kuwait, Riyadh",
            "offset": "+03:00",
            "dst_offset": "+03:00",
            "value": ["Antarctica/Syowa", "Asia/Aden", "Asia/Kuwait", "Asia/Riyadh"]
        }, {
            "label": "(UTC+03:00) Nairobi",
            "offset": "+03:00",
            "dst_offset": "+03:00",
            "value": ["Africa/Addis_Ababa", "Africa/Asmara", "Africa/Asmera", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Kampala", "Africa/Mogadishu", "Africa/Nairobi", "Indian/Antananarivo", "Indian/Comoro", "Indian/Mayotte"]
        }, {
            "label": "(UTC+03:30) Tehran",
            "offset": "+03:30",
            "dst_offset": "+04:30",
            "value": ["Asia/Tehran", "Iran"]
        }, {
            "label": "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
            "offset": "+04:00",
            "dst_offset": "+03:00",
            "value": ["Europe/Moscow", "W-SU"]
        }, {
            "label": "(UTC+04:00) Tbilisi",
            "offset": "+04:00",
            "dst_offset": "+04:00",
            "value": ["Asia/Tbilisi"]
        }, {
            "label": "(UTC+04:00) Yerevan",
            "offset": "+04:00",
            "dst_offset": "+04:00",
            "value": ["Asia/Yerevan"]
        }, {
            "label": "(UTC+04:00) Abu Dhabi, Muscat",
            "offset": "+04:00",
            "dst_offset": "+04:00",
            "value": ["Asia/Dubai", "Asia/Muscat"]
        }, {
            "label": "(UTC+04:00) Baku",
            "offset": "+04:00",
            "dst_offset": "+04:00",
            "value": ["Asia/Baku"]
        }, {
            "label": "(UTC+04:00) Port Louis",
            "offset": "+04:00",
            "dst_offset": "+04:00",
            "value": ["Indian/Mauritius"]
        }, {
            "label": "(UTC+04:30) Kabul",
            "offset": "+04:30",
            "dst_offset": "+04:30",
            "value": ["Asia/Kabul"]
        }, {
            "label": "(UTC+05:00) Tashkent",
            "offset": "+05:00",
            "dst_offset": "+05:00",
            "value": ["Asia/Tashkent"]
        }, {
            "label": "(UTC+05:00) Islamabad, Karachi",
            "offset": "+05:00",
            "dst_offset": "+05:00",
            "value": ["Asia/Karachi"]
        }, {
            "label": "(UTC+05:30) Sri Jayewardenepura Kotte",
            "offset": "+05:30",
            "dst_offset": "+05:30",
            "value": ["Asia/Colombo"]
        }, {
            "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            "offset": "+05:30",
            "dst_offset": "+05:30",
            "value": ["Asia/Calcutta", "Asia/Kolkata"]
        }, {
            "label": "(UTC+05:45) Kathmandu",
            "offset": "+05:45",
            "dst_offset": "+05:45",
            "value": ["Asia/Kathmandu", "Asia/Katmandu"]
        }, {
            "label": "(UTC+06:00) Astana",
            "offset": "+06:00",
            "dst_offset": "+06:00",
            "value": ["Asia/Almaty"]
        }, {
            "label": "(UTC+06:00) Dhaka",
            "offset": "+06:00",
            "dst_offset": "+06:00",
            "value": ["Asia/Dacca", "Asia/Dhaka"]
        }, {
            "label": "(UTC+06:00) Yekaterinburg",
            "offset": "+06:00",
            "dst_offset": "+05:00",
            "value": ["Asia/Yekaterinburg"]
        }, {
            "label": "(UTC+06:30) Yangon",
            "offset": "+06:30",
            "dst_offset": "+06:30",
            "value": ["Asia/Rangoon", "Asia/Yangon"]
        }, {
            "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
            "offset": "+07:00",
            "dst_offset": "+07:00",
            "value": ["Asia/Bangkok", "Asia/Phnom_Penh", "Asia/Vientiane"]
        }, {
            "label": "(UTC+07:00) Novosibirsk",
            "offset": "+07:00",
            "dst_offset": "+07:00",
            "value": ["Asia/Novosibirsk"]
        }, {
            "label": "(UTC+08:00) Krasnoyarsk",
            "offset": "+08:00",
            "dst_offset": "+07:00",
            "value": ["Asia/Krasnoyarsk"]
        }, {
            "label": "(UTC+08:00) Ulaanbaatar",
            "offset": "+08:00",
            "dst_offset": "+08:00",
            "value": ["Asia/Ulaanbaatar", "Asia/Ulan_Bator"]
        }, {
            "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            "offset": "+08:00",
            "dst_offset": "+08:00",
            "value": ["Asia/Chongqing", "Asia/Chungking", "Asia/Harbin", "Asia/Shanghai", "PRC"]
        }, {
            "label": "(UTC+08:00) Perth",
            "offset": "+08:00",
            "dst_offset": "+08:00",
            "value": ["Australia/Perth", "Australia/West"]
        }, {
            "label": "(UTC+08:00) Kuala Lumpur, Singapore",
            "offset": "+08:00",
            "dst_offset": "+08:00",
            "value": ["Asia/Singapore", "Singapore"]
        }, {
            "label": "(UTC+08:00) Taipei",
            "offset": "+08:00",
            "dst_offset": "+08:00",
            "value": ["Asia/Taipei", "ROC"]
        }, {
            "label": "(UTC+09:00) Irkutsk",
            "offset": "+09:00",
            "dst_offset": "+08:00",
            "value": ["Asia/Irkutsk"]
        }, {
            "label": "(UTC+09:00) Seoul",
            "offset": "+09:00",
            "dst_offset": "+09:00",
            "value": ["Asia/Seoul", "ROK"]
        }, {
            "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
            "offset": "+09:00",
            "dst_offset": "+09:00",
            "value": ["Asia/Tokyo", "Japan"]
        }, {
            "label": "(UTC+09:30) Darwin",
            "offset": "+09:30",
            "dst_offset": "+09:30",
            "value": ["Australia/Darwin", "Australia/North"]
        }, {
            "label": "(UTC+09:30) Adelaide",
            "offset": "+09:30",
            "dst_offset": "+10:30",
            "value": ["Australia/Adelaide", "Australia/South"]
        }, {
            "label": "(UTC+10:00) Hobart",
            "offset": "+10:00",
            "dst_offset": "+11:00",
            "value": ["Australia/Currie", "Australia/Hobart", "Australia/Tasmania"]
        }, {
            "label": "(UTC+10:00) Yakutsk",
            "offset": "+10:00",
            "dst_offset": "+09:00",
            "value": ["Asia/Yakutsk"]
        }, {
            "label": "(UTC+10:00) Brisbane",
            "offset": "+10:00",
            "dst_offset": "+10:00",
            "value": ["Australia/Brisbane", "Australia/Queensland"]
        }, {
            "label": "(UTC+10:00) Guam, Port Moresby",
            "offset": "+10:00",
            "dst_offset": "+10:00",
            "value": ["Antarctica/DumontDUrville", "Pacific/Port_Moresby"]
        }, {
            "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
            "offset": "+10:00",
            "dst_offset": "+11:00",
            "value": ["Australia/ACT", "Australia/Canberra", "Australia/NSW", "Australia/Sydney"]
        }, {
            "label": "(UTC+11:00) Vladivostok",
            "offset": "+11:00",
            "dst_offset": "+10:00",
            "value": ["Asia/Vladivostok"]
        }, {
            "label": "(UTC+11:00) Solomon Islands, New Caledonia",
            "offset": "+11:00",
            "dst_offset": "+11:00",
            "value": ["Pacific/Guadalcanal"]
        }, {
            "label": "(UTC+12:00) Coordinated Universal Time+12",
            "offset": "+12:00",
            "dst_offset": "+12:00",
            "value": ["Etc/GMT-12"]
        }, {
            "label": "(UTC+12:00) Fiji, Marshall Islands",
            "offset": "+12:00",
            "dst_offset": "+12:00",
            "value": ["Pacific/Fiji"]
        }, {
            "label": "(UTC+12:00) Magadan",
            "offset": "+12:00",
            "dst_offset": "+11:00",
            "value": ["Asia/Magadan"]
        }, {
            "label": "(UTC+12:00) Auckland, Wellington",
            "offset": "+12:00",
            "dst_offset": "+13:00",
            "value": ["Antarctica/McMurdo", "Antarctica/South_Pole", "NZ", "Pacific/Auckland"]
        }, {
            "label": "(UTC+13:00) Nuku'alofa",
            "offset": "+13:00",
            "dst_offset": "+13:00",
            "value": ["Pacific/Tongatapu"]
        }, {
            "label": "(UTC+13:00) Samoa",
            "offset": "+13:00",
            "dst_offset": "+13:00",
            "value": ["Pacific/Apia"]
        }]
    },
    maintenance: {
        status: false,
        startAt: "",
        duration: 0
    },
    appVersion: '1.1.13.4',
    listOfProvidersOnHome: []
};

const coupons = [{
    description: "Flat 15% off upto 200",
    type: 'percentage',
    maxDiscount: 200,
    minPurchaseRequired: 800,
    value: 15,
}, {
    description: "Flat 250 off on minimum purchase of 800",
    type: 'value',
    maxDiscount: 250,
    minPurchaseRequired: 1000,
    value: 250,
}, {
    description: "Flat 20% off upto 300",
    type: 'percentage',
    maxDiscount: 300,
    minPurchaseRequired: 1000,
    value: 20,
}, {
    description: "Flat 200 off on minimum purchase of 800",
    type: 'value',
    maxDiscount: 200,
    minPurchaseRequired: 800,
    value: 200,
}];

const vouchers = [{
    amount: 500
}, {
    amount: 350
}, {
    amount: 400
}, {
    amount: 600
}];

const messages = [{
    author: "client",
    body: "Hello"
}, {
    author: "provider",
    body: "Hello"
}, {
    author: "provider",
    body: "How are you doing?"
}, {
    author: "client",
    body: "Hello"
}, {
    author: "provider",
    body: "Hello"
}, {
    author: "client",
    body: "Hello"
}, {
    author: "provider",
    body: "Hello"
}, {
    author: "user",
    body: "Hello"
}, {
    author: "provider",
    body: "Hello"
}, {
    author: "provider",
    body: "Hello"
}, {
    author: "client",
    body: "Hello"
}, {
    author: "client",
    body: "Hello"
}, {
    author: "provider",
    body: "Hello"
}, {
    author: "client",
    body: "Hello"
}];

const clientSubscriptionPlans = [{
    _id: "clientSubscriptionPlan1",
    serviceDetails: {
        call: 2,
        video: 2,
        inPerson: 0,
        report: false
    },
    isActive: true,
    name: "Free",
    amount: 0,
    period: "Month",
    razorpayPlanId: "",
    provider: "provider1",
    createdAt: "",
    updatedAt: "",
}, {
    _id: "clientSubscriptionPlan2",
    serviceDetails: {
        call: 4,
        video: 4,
        inPerson: 1,
        report: true
    },
    isActive: true,
    name: "Basic",
    amount: 399900,
    period: "Month",
    razorpayPlanId: "razorpayPlanId1",
    provider: "provider1",
    createdAt: "",
    updatedAt: "",
}, {
    _id: "clientSubscriptionPlan3",
    serviceDetails: {
        call: 6,
        video: 6,
        inPerson: 2,
        report: true
    },
    isActive: true,
    name: "Pro",
    amount: 699900,
    period: "Month",
    razorpayPlanId: "razorpayPlanId2",
    provider: "provider1",
    createdAt: "",
    updatedAt: "",
}];

const clientSubscriptions = [{
    _id: "clientSubscription1",
    serviceDetails: {
        call: {
            history: ["session1"],
            currentCycleUsage: 1
        },
        video: {
            history: [],
            currentCycleUsage: 0
        },
        inPerson: {
            history: [],
            currentCycleUsage: 0
        },
        report: false
    },
    isActive: true,
    isUpdated: false,
    isCancelled: false,
    razorpaySubscriptionId: "razorpaySubscriptionId1",
    clientSubscriptionPlan: clientSubscriptionPlans[1],
    provider: counsellors[0],
    client: clients[0],
    conversation: "conversation1",
    createdAt: "",
    updatedAt: ""
}];

const counsellorPaymentRecords = [{
    _id: "counsellorPaymentRecord1",
    providerEmail: counsellors[0].email,
    paymentInformation: [{
        providerName: `${counsellors[0].title} ${counsellors[0].firstName} ${counsellors[0].lastName}`,
        providerEmail: counsellors[0].email,
        fromDate: "",
        toDate: "",
        gstPercentage: 0,
        amountEarned: 1000,
        netAmountAfterDeductingRazorpayCharges: 970,
        expectedPaymentDate: "",
        paidOnDate: "",
        isProcessed: true
    }, {
        providerName: `${counsellors[0].title} ${counsellors[0].firstName} ${counsellors[0].lastName}`,
        providerEmail: counsellors[0].email,
        fromDate: "",
        toDate: "",
        gstPercentage: 0,
        amountEarned: 2000,
        netAmountAfterDeductingRazorpayCharges: 1940,
        expectedPaymentDate: "",
        paidOnDate: "",
        isProcessed: true
    }],
}, {
    _id: "counsellorPaymentRecord2",
    providerEmail: counsellors[1].email,
    paymentInformation: [],
    createdAt: "",
    updatedAt: ""
}];

const counsellorSubscriptionPaymentRecord = [{
    _id: 'counsellorSubscriptionPaymentRecord1',
    providerName: `${counsellors[0].title} ${counsellors[0].firstName} ${counsellors[0].lastName}`,
    providerEmail: counsellors[0].email,
    paymentInformation: [{
        fromDate: "",
        toDate: "",
        amountEarned: 3999,
        gstPercentage: 0,
        razorpayCharges: 136.86,
        netAmountAfterDeductingCharges: 3862.14,
        expectedPaymentDate: "",
        isProcessed: true,
        paidOnDate: ""
    }, {
        fromDate: "",
        toDate: "",
        amountEarned: 6999,
        gstPercentage: 0,
        razorpayCharges: 238,
        netAmountAfterDeductingCharges: 6761,
        expectedPaymentDate: "",
        isProcessed: true,
        paidOnDate: ""
    }]
}];

const providerSubscriptionPlans = [{
    _id: "providerSubscriptionPlan1",
    serviceDetails: {
        sessionBookingLimit: 3,
        clientLimit: 2,
        modeOfServices: {
            call: true,
            chat: false,
            inPerson: false,
            video: false
        },
        createClientSubscriptionPlans: false
    },
    isActive: true,
    name: "Free",
    amount: 0,
    razorpaySubscriptionPlanId: ""
}, {
    _id: "providerSubscriptionPlan2",
    serviceDetails: {
        sessionBookingLimit: 8,
        clientLimit: 4,
        modeOfServices: {
            call: true,
            chat: false,
            inPerson: false,
            video: true
        },
        createClientSubscriptionPlans: false
    },
    isActive: false,
    name: "Basic",
    amount: 299900,
    razorpaySubscriptionPlanId: "razorpaySubscriptionPlanId1"
}, {
    _id: "providerSubscriptionPlan3",
    serviceDetails: {
        sessionBookingLimit: 12,
        clientLimit: 6,
        createClientSubscriptionPlans: true,
        modeOfServices: {
            call: true,
            chat: true,
            video: true,
            inPerson: true
        }
    },
    isActive: true,
    name: "Pro",
    amount: 599900,
    razorpaySubscriptionPlanId: "razorpaySubscriptionPlanId2"
}];

const providerSubscriptions = [{
    _id: "subscription0156",
    isActive: true,
    isUpdated: true,
    isCancelled: false,
    razorpaySubscriptionId: "razorpaySubscriptionId1",
    providerSubscriptionPlan: providerSubscriptionPlans[2],
    provider: "",
    subscriptionCycle: [{
        serviceDetails: {
            modeOfServices: {
                call: true,
                chat: true,
                video: false,
                inPerson: false
            },
            sessionBookingLimit: 30,
            clientLimit: 10,
            sessionBookingCount: 0,
            clientCount: 0,
            createClientSubscriptionPlans: true
        },
        _id: "",
        startDate: "",
        endDate: "",
        razorpayPaymentId: "pay_K5uCyKwCyr41Fv",
        amountPaid: 3999,
        currency: "INR"
    }, {
        serviceDetails: {
            modeOfServices: {
                call: true,
                chat: true,
                video: true,
                inPerson: true
            },
            sessionBookingLimit: 10,
            clientLimit: 5,
            sessionBookingCount: 3,
            clientCount: 1,
            createClientSubscriptionPlans: true
        },
        _id: "",
        startDate: "",
        endDate: "",
        razorpayPaymentId: "pay_K5uCyKwCyr41Fv",
        amountPaid: 5999,
        currency: "INR"
    }],
    createdAt: "",
    nextChargeAt: ""
}];

module.exports = {
    profileImage1, users, clients, counsellors, sessions, siteVariable, coupons, vouchers,
    messages, clientSubscriptions, clientSubscriptionPlans, counsellorPaymentRecords, counsellorSubscriptionPaymentRecord,
    providerSubscriptionPlans, providerSubscriptions
}